import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../api";
import { Spinner, Pill } from "../ui";

export default function Profile() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/decision-profile").then((r) => setData(r.data)).catch(() => setData({ insights: [] }));
  }, []);

  if (!data) return <Spinner label="Reading your patterns…" />;

  const insights = data.insights || [];

  const verdict = async (iid, v) => {
    try {
      await api.patch(`/decision-profile/insights/${iid}`, { verdict: v });
      toast.success("Noted.");
    } catch {
      toast.error("Could not save that.");
    }
  };

  return (
    <div data-testid="profile-page" className="max-w-3xl">
      <p className="font-mono-label text-[10px] tracking-[0.3em] uppercase text-[#B5A58A]/80 mb-4">Decision Profile</p>
      <h1 className="font-serif-display font-light tracking-tighter text-5xl md:text-6xl text-white mb-6">Your patterns, <span className="italic">named.</span></h1>
      <p className="text-sm leading-relaxed text-stone-400 mb-12 max-w-xl">
        Recurring goals, constraints, and habits the board has noticed across your cases. Patterns, not diagnoses — correct anything that misses.
      </p>

      {insights.length === 0 ? (
        <p className="text-sm text-stone-500" data-testid="profile-empty">
          Nothing yet. Resolve a few cases and the board will start connecting the dots.
        </p>
      ) : (
        <div className="space-y-4">
          {insights.map((ins, i) => (
            <div key={ins.id || i} className="bg-[#26241F] border border-white/[0.08] rounded-2xl p-6" data-testid={`insight-${ins.id || i}`}>
              <p className="text-sm md:text-base leading-relaxed text-stone-200 mb-4">{ins.content || ins.text || ins.insight}</p>
              <div className="flex gap-2">
                {["accurate", "partly", "not"].map((v) => (
                  <button
                    key={v}
                    data-testid={`insight-verdict-${v}-${ins.id || i}`}
                    onClick={() => verdict(ins.id, v)}
                    className="rounded-full px-4 py-1.5 font-mono-label text-[9px] tracking-[0.15em] uppercase border border-white/[0.12] text-stone-400 hover:text-white hover:border-[#B5A58A]/50 transition-colors duration-300"
                  >
                    {v === "not" ? "Not me" : v}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
